import { GenericError, NotFoundError, handleNetworkResponse } from '@/lib/error'

export function putAttachment(
  presignedPutUrl: string,
  file: File
): Promise<void> {
  return (
    fetch(presignedPutUrl, {
      method: 'put',
      headers: {
        'Content-Type': file.type
      },
      body: file
    })
      .then(handleNetworkResponse)
      // The above ensures we get a successful network response
      .then(() => {})
      .catch((e: unknown) => {
        if (e instanceof NotFoundError) throw e
        throw new GenericError()
      })
  )
}
